import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Select from 'react-select'
import Button from 'react-bootstrap/Button'
import Popover from 'react-bootstrap/Popover'
import Modal from 'react-bootstrap/Modal'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Form from "react-bootstrap/Form"
import Spinner from 'react-bootstrap/Spinner'
import moment from 'moment'
import DatePicker from "react-datepicker"
import { selectTrainerParam,getAllClients } from '../users/usersSlice'
import { createCalendarEvent, editCalendarEvent, deleteCalendarEvent, editEndDate } from "../../state/schedulerSlice"
import MultiSelect from "react-multi-select-component";
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import "./styles.css"
import TimePicker from '../TimePicker/TimePicker'
import { v4 as uuidv4 } from 'uuid';
import { process24Hour, addZero, dateToTimeObj, getTimeString } from '../../util/datetime'
import { repeat } from 'lodash'
import ReadableRepeat from './ReadableRepeat';
import { createIcsFile, createLink, determineClient, determineDeletePermissions, determineInterval, mapToDays, openLink } from './utilities'
import DeductSessionCheck from '../DeductSessionCheck/DeductSessionCheck'
import useCurrentUser from '../../hooks/useCurrentUser'

function ScheduleModal({
    showScheduleModal,
    setShowScheduleModal,
    scheduleEventData,
    setScheduleEventData,
    editData,
    setEditData,
    editSeries,
    setEditSeries,
    getEvents,
    currentView
}) {

    const statusDispatch = useApiStatusDispatch()

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("")
    const [link, setLink] = useState("")
    const [chosenType, setChosenType] = useState({
        label: "Training Session",
        value: "training"
    })
    const [status, setStatus] = useState("")
    const [chosenReminder, setChosenReminder] = useState("")
    const [isClientListLoading, setIsClientListLoading] = useState(false)

    const isTrainer = useSelector( state => state.users.current_user.account_type ) === 'trainer'
    const isGym = useSelector( state => state.users.current_user.account_type ) === 'gym'
    const isTrainerOrGym = isTrainer || isGym;

    const isClient = useSelector( state => state.users.current_user.account_type ) === 'client'
    const user = useCurrentUser()
    const isOwner = (
        parseInt(user.gym_id) !== 0
        ? isGym
        : isTrainer
    )

    //24 hour time setting 
    const isTime24Hour = Number(
        useSelector( 
            state => state.users.current_user.is_24_hour_time 
        )
    )

    const url = new URL(window.location.href);
    const trainerId = url.searchParams.get("trainer");
    const trainerParam = useSelector(selectTrainerParam)
    const [selectedType, setSelectedType] = useState('All')

    // none | daily | weekly

    const [frequencyError, setFrequencyError] = useState(false);
    const [dateError, setDateError] = useState(false);
    const [dateErrors,setDateErrors] = useState([])

    const [repeatType, setRepeatType] = useState({ value: "none", label: "None" })
    const [endDate, setEndDate] = useState()
    const [editEndDateLoading, setEditEndDateLoading] = useState(false)

    const [dailyString, setDailyString] = useState('1')
    const [customDayString, setCustomDayString] = useState("");
    const [startDate, setStartDate] = useState("")
    const [noEndDate, setNoEndDate] = useState("");
    const [clientsFormatted, setClientsFormatted] = useState([]);

    const [groupSessionSize,setGroupSessionSize] = useState('')
    const [consumeCreditForGroupSession,setConsumeCreditForGroupSession] = useState(false)

    const [deductSession,setDeductSesion] = useState(false)
    const [deductSessions,setDeductSesions] = useState(false)

    const [startTime, setStartTime] = useState({
        hour: '12',
        min: '00',
        p: 'p'
    })

    const [endTime, setEndTime] = useState({
        hour: '1',
        min: '00',
        p: 'p'
    })

    const [repeatWeekDays, setRepeatWeekDays] = useState([])
    const [weekRepeatFreq, setWeekRepeatFreq] = useState("1");

    const [selectedClients, setSelectedClients] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [createSessionWorkouts,setCreateSessionWorkouts] = useState(true)

    let dispatch = useDispatch();

    const [pushNotifications, setPushNotifications] = useState(false);
    const [emailNotifications, setEmailNotifications] = useState(false);

    const [signupCancelBuffer,setSignupCancelBuffer] = useState(0)

    //clear all modal data
    function clearData() {
        setTitle("");
        setDescription("");
        setFrequencyError(false);
        setDateError(false);
        setDateErrors([])
        setLink('')
        setRepeatType({ value: "none", label: "None" })
        setDailyString("1")
        setCustomDayString((""))
        setWeekRepeatFreq("1");
        setRepeatWeekDays([]);
        setStartDate(new Date())
        setEndDate("")
        setStartTime({
            hour: '',
            min: '',
            p: 'p'
        })
        setEndTime({
            hour: '',
            min: '',
            p: 'p'
        })
        setSelectedType("All")
        setEditData("")
        setEditSeries(false);
        setSelectedClients([]);
        setChosenReminder("")
        setChosenType({
            label: "Training Session",
            value: "training"
        })
        setNoEndDate(false);
        setConfirmDelete(false)
        setPushNotifications(false);
        setEmailNotifications(false);
        setCreateSessionWorkouts(true)
    }

    //gets clientlist from store then converts to array and sorts by name
    const allClients = useSelector(state => state.users.clients.entities)

    useEffect(() => {
        let formatted = Object.values(allClients).sort(function (a, b) {
            let textA = a.user_name.toUpperCase();
            let textB = b.user_name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
            .map(client => (
                {
                    label: client.user_name,
                    value: client.user_id_number,
                    key: client.user_id_number,
                }
            ))
        setClientsFormatted(formatted)
    }, [allClients])


    //upon selecting a client, finds the client object
    const handleSelectClient = (newClient) => {
        setSelectedClients(newClient)
    }

    // return correct Object format for React Select 
    function createTypeObject(type) {
        if (type === "training") {
            return { value: "training", label: "Training Session", }
        } else if (type === "personal") {
            return { value: "personal", label: "Personal/Unavailable" }
        } else if (type === "group_session"){
            return { value: "group_session", label: "Class"}
        } else if (type === "semi_private"){
            return { value: "semi_private", label: "Semi-private training session"}
        } else if (type === "notes"){
            return { value: "notes", label: "Notes"}
        }
    }

    const reminderOptions = [
        {
            label: "None",
            value: "0"
        },
        {
            label: "Send 48 Hours Before Event",
            value: "48"
        },
        {
            label: "Send 24 Hours Before Event",
            value: "24"
        },
        {
            label: "Send 12 Hours Before Event",
            value: "12"
        },
        {
            label: "Send 6 Hours Before Event",
            value: "6"
        },
        {
            label: "Send 1 Hour Before Event",
            value: "1"
        }
    ]


    function formattedUsers(allClients) {
        let formatted = Object.values(allClients).sort(function (a, b) {
            let textA = a.user_name.toUpperCase();
            let textB = b.user_name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
            .map(client => (
                {
                    label: client.user_name,
                    value: client.user_id_number,
                    key: client.user_id_number,
                }
            ))
        return formatted
    }
    //fill in local state from Scheduler data
    // this will fire when clicking to edit a calendar event
    useEffect(() => {
        if (editData) {
            editData.title && setTitle(editData.title);
            editData.body && setDescription(editData.body);
            editData.link && setLink(editData.link);
            editData.event_type && setChosenType(createTypeObject(editData.event_type));
            setEmailNotifications(editData.send_email)
            setPushNotifications(editData.send_pushnote)
            setCreateSessionWorkouts(Boolean(editData.create_workouts))
            setSignupCancelBuffer(editData.signup_cancel_buffer)
            let startDate;
            let endDate;
            if (editData.client_ids) {
                let formattedDBClients = [];
                let dbClients = (editData.client_ids).split(",");
                let formattedClients = formattedUsers(allClients);

                formattedClients?.map(client => {
                    dbClients?.map(item => {
                        if (client.value == item) {
                            formattedDBClients.push({
                                label: client.label,
                                value: client.value,
                                key: client.value
                            })
                        }
                    })
                })

                setSelectedClients(formattedDBClients);


            }
            let filteredReminderOptions = reminderOptions.filter(item => item.value == editData.reminder_time)[0]

            setChosenReminder(filteredReminderOptions);

            // start date and end date for logic for singular event vs series
            if (editSeries) {
                startDate = editData.seriesStartDate;
                endDate = editData.seriesEndDate;

                if (editData.no_end_date === "1") {
                    setNoEndDate(true);
                } else {
                    setEndDate(endDate);
                }


                editData.recurrence_type && setRepeatType(
                    {
                        value: editData.recurrence_type,
                        label: editData.recurrence_type === "day" ? "Daily" : "Weekly"
                    })

                if (Number(editData?.repeat_frequency) > 10) {
                    setCustomDayString(editData?.repeat_frequency)
                } else {
                    setDailyString(editData?.repeat_frequency)
                }

                if (editData.recurrence_type === "week") {
                    setWeekRepeatFreq(editData?.repeat_frequency||'1')
                    let weekdays = mapToDays(editData.week_days)
                    setRepeatWeekDays(weekdays);
                }



            } else {
                startDate = editData.start
                endDate = editData.end
            }

            setConsumeCreditForGroupSession(Boolean(editData.consume_session_credit))
            setGroupSessionSize(editData.group_session_size)
            setStartDate(startDate)
            startDate && setStartTime(dateToTimeObj(startDate, 1))
            endDate && setEndTime(dateToTimeObj(endDate, 1))

        } else {
            clearData();
        }
    }, [editData, editSeries])


    // this will fire after clicking to create a new calendar event
    useEffect(() => {
        if (scheduleEventData) {
            // data derived from click/select calendar          
            const { action, start, end } = scheduleEventData

            // start Date selected
            const startDateObj = new Date(start)
            // start Date Time Object

            // set Start Date
            setStartDate(start)

            setCreateSessionWorkouts(true)

            // if calendar is in month view then do not set time values. 
            if (currentView === "month") {
                return;
            }

            // set start time
            let startTimeObj = dateToTimeObj(startDateObj, 1)
            setStartTime(startTimeObj)

            // if action == select then there will be both a start time and an end time set
            if (action === "select") {
                const endDateObj = new Date(end)
                setEndDate(end)
                setEndTime(dateToTimeObj(endDateObj, 1))
                setRepeatType({ value: "none", label: "None" })
                // make the end time be the start time plus 1 hour
            } else {
                let returned_endDate = moment(startDateObj).add(1, 'hours')
                let regularDateObj = returned_endDate.toDate()
                setEndTime(dateToTimeObj(regularDateObj, 1))
            }
        }
    }, [scheduleEventData])
    //helper function for adding/removing a day from the 
    //array of repeat weekdays
    const toggleWeeklyDayString = (day) => {
        if (repeatWeekDays.includes(day)) {
            setRepeatWeekDays(repeatWeekDays.filter(d => d !== day))
        } else {
            setRepeatWeekDays([...repeatWeekDays, day])
        }
    }

    //upon type selection sets the selectedType state
    const handleTypeSelect = (e) => {
        let type = (e.label).toLowerCase()
        setSelectedType(type)
    }

    // format date string for database
    function formatDateString(date, time) {
        let dateString = moment(date).format("YYYY-MM-DD") + "T" + getTimeString(time, true)
        return moment(dateString).format("YYYY-MM-DD HH:mm:ss")
    }

    //array of available event types
    const eventOptions = [
        { label: 'All', value: 1 },
        { label: 'Workout', value: 2 },
        { label: 'Nutrition', value: 3 },
        { label: 'Task', value: 4 },
    ]

    function codeWeekdays(repeatWeekDays) {
        let mappedDays = repeatWeekDays.map(item => {
            switch (item) {
                case "Sun": return "0";
                case "Mon": return "1";
                case "Tue": return "2";
                case "Wed": return "3";
                case "Thu": return "4";
                case "Fri": return "5";
                case "Sat": return "6";
            }
        })
        mappedDays = mappedDays.join(",")
        return mappedDays;
    }

    const [confirmDelete, setConfirmDelete] = useState(false)
    const dispatchDelete = () => {
        let payload = {
            edit_series: editSeries ? "1" : "0",
            action: "deleteCalendarEvent",
            event_type: chosenType.value,
            event_id: editData.id,
            old_start_date: moment(editData.start).format("YYYY-MM-DD HH:mm:ss")
        }

        setIsDeleting(true);
        statusDispatch(deleteCalendarEvent(payload), "event", "delete")
            .then(() => {
                getEvents();
                setShowScheduleModal(false);
                clearData();
                setIsDeleting(false);
            })
    }

    function handleDeleteEvent() {
        setConfirmDelete(true)
    }

    function handleEditEndDate() {

        let formattedEndDate;

        let endTime = dateToTimeObj(editData.seriesEndDate, isTime24Hour)

        if (noEndDate) {
            formattedEndDate = getTimeString(endTime, 1)
        } else {
            formattedEndDate = formatDateString(endDate, endTime)
        }

        if (formattedEndDate === "Invalid date") {
            setDateErrors(p=>[...p,'end_date'])
            setDateError(true)
            return
        }
        let payload = {
            action: "editEndDate",
            end_date: formattedEndDate,
            no_end_date: noEndDate ? "1" : "0",
            event_id: editData.id,
        }

        setEditEndDateLoading(true);
        statusDispatch(editEndDate(payload), "event", "edit")
            .then(() => {
                getEvents();
                setShowScheduleModal(false);
                clearData();
                setEditEndDateLoading(false);
            })

    }

    const statusColor = (status) => (
        // status = requested
        {
            color: status == "0" ? "rgb(161 132 26)" :
                // status = deleted
                status == "2" ? "#dc3545" :
                    // default black
                    "black"
        }
    )





    function handleCreateLink(download) {
        let repeatTypeValue = repeatType.value
        let interval = determineInterval(repeatTypeValue, dailyString, customDayString, weekRepeatFreq);

        let start = {
            startDate: startDate,
            startTime: startTime
        }

        let end = {
            endDate: endDate,
            endTime: endTime,
            noEndDate: noEndDate,
        }


        return createLink(
            download,
            start,
            end,
            title,
            description,
            repeatTypeValue,
            repeatWeekDays,
            interval
        )
    }

    const validate = ()=>{
        let formattedStartDate = formatDateString(startDate, { hour: '00', min: '00', p: 'p' })
        let formattedStartTime = formatDateString(new Date(), startTime)

        let formattedEndDate;
        if (repeatType.value === "none") {
            // use startDate for day/month/year, but use endTime
            formattedEndDate = formatDateString(startDate, { hour: '00', min: '00', p: 'p' })
        } else {
            if (noEndDate) {
                formattedEndDate = getTimeString(endTime, 1)
            } else {
                formattedEndDate = formatDateString(endDate, { hour: '00', min: '00', p: 'p' })
            }
        }

        let formattedEndTime;
        if (repeatType.value === "none") {
            // use startDate for day/month/year, but use endTime
            formattedEndTime = formatDateString(new Date(), endTime)
        } else {
            if (noEndDate) {
                formattedEndTime = getTimeString(endTime, 1)
            } else {
                formattedEndTime = formatDateString(new Date(), endTime)
            }
        }
        const errors = []

        if (formattedStartDate === "Invalid date") {
            errors.push('start_date')
        }

        if (formattedStartTime === "Invalid date" || formattedEndTime === "Invalid date") {
            errors.push('time_range')
        }

        if (formattedEndDate === "Invalid date" ) {
            errors.push('end_date')
        }

        if (repeatType.value === "week") {
            if (repeatWeekDays.length === 0) {
                errors.push('missing_weekdays')
            }
        }

        setDateErrors(errors)

        return errors.length === 0
    }

    function handleSaveEvent(status = null) {
        

        let formattedStartDate = formatDateString(startDate, { hour: '00', min: '00', p: 'p' })
        let formattedStartDateTime = formatDateString(startDate, startTime)

        let formattedEndDate;
        if (repeatType.value === "none") {
            // use startDate for day/month/year, but use endTime
            formattedEndDate = formatDateString(startDate, { hour: '00', min: '00', p: 'p' })
        } else {
            if (noEndDate) {
                formattedEndDate = getTimeString(endTime, 1)
            } else {
                formattedEndDate = formatDateString(endDate, { hour: '00', min: '00', p: 'p' })
            }
        }

        let formattedEndDateTime;
        if (repeatType.value === "none") {
            // use startDate for day/month/year, but use endTime
            formattedEndDateTime = formatDateString(startDate, endTime)
        } else {
            if (noEndDate) {
                formattedEndDateTime = getTimeString(endTime, 1)
            } else {
                formattedEndDateTime = formatDateString(endDate, endTime)
            }
        }

        const isValid = validate()

        if (!isValid) return

        let clientString = selectedClients
            .map( client => client.value )
            .join(",")

        let payload = {
            action: editData ? "editCalendarEvent" : "createCalendarEvent",
            start_date: formattedStartDateTime,
            end_date: formattedEndDateTime,
            recurrence_type: repeatType.value,
            no_end_date: noEndDate ? "1" : "0",
            signup_cancel_buffer:signupCancelBuffer,
            body: description,
            title: title,
            link: link,
            event_type: chosenType.value,
            client_ids: clientString,
            event_id: editData ? editData.id : null,
            event_status: status,
            reminder_time: chosenReminder.value,
            push_notifications: pushNotifications ? "1" : "0",
            email_notifications: emailNotifications ? "1" : "0",
            deduct_session: Number(deductSession),
            group_session_size:groupSessionSize,
            consume_session_credit:Number(consumeCreditForGroupSession),
            create_workouts:Number(createSessionWorkouts),
            deduct_sessions:Number(deductSessions)
        }

        if (repeatType.value === 'day') {
            if (dailyString === "custom") {
                payload.day_string = customDayString;
            } else {
                payload.day_string = dailyString;
            }
        } else {
            let day_string = codeWeekdays(repeatWeekDays)
            payload.day_string = day_string;
            payload.week_repeat_freq = Number(weekRepeatFreq) < 1 ? "1" : weekRepeatFreq;
        }

        if (status == "2") {
            setIsDeleting(true)
        } else {
            setIsSaving(true);
        }

        if (editData) {

            payload.edit_series = editSeries ? "1" : "0"
            let old_start_date = moment(editData.start).format("YYYY-MM-DD HH:mm:ss")
            payload.old_start_date = old_start_date;
            statusDispatch(editCalendarEvent(payload), "event", "edit")
                .then((action) => {
                    setIsSaving(false);
                    setIsDeleting(false);
                    if(action.payload.success==='1'){
                        getEvents();
                        setShowScheduleModal(false);
                        clearData();   
                    }else {
                        window.alert(action.payload.message)
                    }
                })
        } else {
            statusDispatch(createCalendarEvent(payload), "event", "create")
                .then((action) => {
                    setIsSaving(false);
                    setIsDeleting(false);
                    if(action.payload.success==='1'){
                        getEvents();
                        setShowScheduleModal(false);
                        clearData()
                    } else {
                        window.alert(action.payload.message)
                    }
                })
        }
    }

    const repeatEvent = () => {
        return (
            <>
                <Row className="mb-1 mt-4">
                    <Col sm="12">
                        <Form.Label>Repeat</Form.Label>
                    </Col>
                    <Col sm="12" md="6">
                        <Select class="form-select"
                            isSearchable={false}
                            options={[
                                { value: "none", label: "None" },
                                { value: "day", label: "Daily" },
                                { value: "week", label: "Weekly" }
                            ]}
                            value={repeatType}
                            onChange={e => {
                                setRepeatType(e)
                            }}
                        />
                    </Col>
                </Row>
                {repeatType.value !== 'none' &&
                    <>
                        <Row className="mb-1 mt-2" >
                            <hr style={{ width: "90%", background: "#b6b6b6" }} />
                            <Col sm="12" className="mt-1">
                                <Form.Label >Repeat Until</Form.Label>
                            </Col>

                            <Col sm={editData ? "5" : "12"}  >
                                <DatePicker
                                    disabled={noEndDate}
                                    className="form-control"
                                    dateFormat="MMM dd, yyyy"
                                    onChange={newDate => {
                                        setEndDate(newDate)
                                        setDateErrors(p=>p.filter(e=>e!=='end_date'))
                                        setFrequencyError(false)
                                    }}
                                    selected={endDate}
                                />
                            </Col>
                            <Col sm="12" md="12" style={{ marginTop: "15px" }} className=" ml-2">
                                <Form.Check
                                    checked={noEndDate}
                                    label={`No End Date`}
                                    onChange={e => {
                                        setNoEndDate(prev => !prev)
                                        setDateErrors(p=>p.filter(e=>e!=='end_date'))
                                    }}
                                    name="noEndDate"
                                    id="noEndDate"
                                    type="checkbox"
                                />
                                {dateErrors.includes('end_date')&&
                                    <small className="d-block text-danger">
                                        Please enter a valid end date
                                    </small>
                                }
                            </Col>
                            <hr style={{ width: "90%", background: "#b6b6b6" }} />
                        </Row>

                        {repeatType.value === 'day' &&
                            <Row className="mb-1 mt-2">
                                <Col sm="12">
                                    <Form.Label >Repeat Frequency </Form.Label>
                                </Col>
                                <Col sm="12" md="6">
                                    <Form.Control as={"select"}
                                        value={dailyString}
                                        onChange={e => {
                                            setDailyString(e.target.value)
                                            setCustomDayString("")
                                        }
                                        }
                                        placeholder="days"
                                    >
                                        {/*<option value="3x"> Three Times Per Day </option>
                                        <option value="2x"> Two Times Per Day </option>*/}
                                        {/*<option value="workDays"> Every Work Day (Mon-Fri)</option>*/}
                                        <option value="1"> Every Day </option>
                                        <option value="2"> Every 2nd Day </option>
                                        <option value="3"> Every 3rd Day </option>
                                        <option value="4"> Every 4th Day </option>
                                        <option value="5"> Every 5th Day </option>
                                        <option value="6"> Every 6th Day </option>
                                        <option value="7"> Every 7th Day </option>
                                        <option value="8"> Every 8th Day </option>
                                        <option value="9"> Every 9th Day </option>
                                        <option value="10"> Every 10th Day </option>
                                        <option value="custom"> Custom </option>
                                    </Form.Control>
                                </Col>
                            </Row>}

                        {dailyString === "custom" &&
                            <Row className="mb-1 mt-2">
                                <Col sm="12">
                                    <Form.Label >Custom Repeat Frequency </Form.Label>
                                </Col>
                                <Col sm="12" md="6">
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        onChange={e => {
                                            setCustomDayString(e.target.value)
                                            setFrequencyError(false)
                                        }}
                                        placeholder="days"
                                    />
                                </Col>

                            </Row>}

                        {repeatType.value === 'week' &&
                            <>
                                <Row className="mb-1">
                                    <Col sm="12" className="mt-2">
                                        <Form.Label>Repeat Frequency (in weeks)</Form.Label>
                                    </Col>
                                    <Col sm="12" md="6" >
                                        <Form.Control
                                            type="number"
                                            placeholder="weeks"
                                            value={weekRepeatFreq}
                                            onChange={e => {
                                                setWeekRepeatFreq(e.target.value)
                                            }}
                                        />
                                        <div>
                                            <small className="text-info">
                                                {weeklyRepeatString()}
                                            </small>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="mb-1">
                                    <Col sm="12" className="mt-2">
                                        <Form.Label>Choose Days</Form.Label>
                                    </Col>
                                    <Col sm="12" lg="12">
                                        <div className="d-md-flex justify-content-around">
                                            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
                                                <Form.Check
                                                    checked={repeatWeekDays.includes(d)}
                                                    onChange={() => {
                                                        setDateErrors(p=>p.filter(e=>e!=='missing_weekdays'))
                                                        toggleWeeklyDayString(d)
                                                    }}
                                                    key={`weekly-${d}`}
                                                    label={d}
                                                />
                                            ))}
                                        </div>
                                        {dateErrors.includes('missing_weekdays') &&
                                            <div className="text-danger ml-3 mb-2">
                                                select at least one day
                                            </div>
                                        }
                                    </Col>

                                </Row>
                            </>
                        }

                        <ReadableRepeat
                            repeatType={repeatType.value}
                            eventType="event"
                            startDate={startDate}
                            endDate={endDate}
                            repeatData={
                                repeatType.value === 'day' ?
                                    customDayString ? customDayString : dailyString :
                                    repeatWeekDays
                            }
                            noEndDate={noEndDate}
                            weekRepeatFreq={weekRepeatFreq}
                        />
                    </>
                }



            </>
        )
    }

    const weeklyRepeatString = ()=>{
        if(!weekRepeatFreq){
            return 'Input a number'
        }else if(parseInt(weekRepeatFreq)===1){
            return 'Repeat every week'
        }else if(parseInt(weekRepeatFreq)===2){
            return 'Repeat every other week'
        }else{
            return `Repeat every ${weekRepeatFreq} weeks`
        }
        
    }

    const eventTypeOptions =  [
        {
            label: "Training Session",
            value: "training"
        },
        {
            label: "Semi-private training session",
            value: "semi_private"
        },
        {
            label: "Personal/Unavailable",
            value: "personal"
        },
        {
            label: "Class",
            value: "group_session"
        },
        {
            label: "Notes",
            value: "notes"
        },
    ]

    if(isOwner){
        eventTypeOptions.push({
            label: "Closed",
            value: "clientsFormatted"
        })
    }

    console.log(editData)

    return (
        <Modal show={showScheduleModal} className="myCalendarEditAddModal myCalendarCloseButton" onHide={() => {
            setConfirmDelete(false)
            setShowScheduleModal(false)
            clearData()
        }}>
            <Modal.Header closeButton>
                <Modal.Title>{editData ?
                    <span> Edit Event
                        {editSeries ? " Series" : null}
                        {!isClient && <span style={statusColor(editData.status)}>
                            {editData.status == "0" ? ` (Requested by ${determineClient(allClients, editData.client_ids)})` :
                                // status = deleted
                                editData.status == "2" ? " (Deleted)" :
                                    // default black
                                    null}
                        </span>}
                    </span>
                    : <span> {isClient ? "Request Training Session" : "Add Event"} </span>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>

                    <Form.Group>
                        <Form.Label> Title </Form.Label>
                        <Form.Control
                            value={title}
                            onChange={(e) => setTitle(e.target.value)} />

                    </Form.Group>
                    <Form.Group>
                        <Form.Label> Description </Form.Label>
                        <Form.Control
                            value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label> Link </Form.Label>
                        <Form.Control
                            value={link}
                            onChange={(e) => setLink(e.target.value)} />
                    </Form.Group>

                    <Form.Group as={Row} className="mb-1 mt-2 w-100" >
                        <Col sm="12" >
                            <Form.Label >Start Date</Form.Label>
                        </Col>
                        <Col sm="12" lg="10" >
                            <DatePicker
                                className="form-control"
                                dateFormat="MMM dd, yyyy"
                                onChange={ newDate => {
                                    setDateError(false)
                                    setDateErrors(p=>p.filter(e=>e!=='start_date'))
                                    setStartDate(newDate)
                                }}
                                selected={startDate}
                            />
                            {dateErrors.includes('start_date')&&
                                <small className="d-block text-danger">
                                    Please enter a valid start date
                                </small>
                            }
                        </Col>
                    </Form.Group>
                    <div className="mt-4 mb-1"> Time Range </div>
                    <Row className="mb-1">
                        <Col>
                            <div className="d-md-flex align-items-center">
                                <TimePicker
                                    onChange={newTimeObj=>{
                                        setDateErrors(p=>p.filter(e=>e!=='time_range'))
                                        setStartTime(newTimeObj)
                                    }}
                                    minuteInterval={15}
                                    hour={startTime.hour}
                                    minute={startTime.min}
                                    period={startTime.p}
                                    isTime24Hour={isTime24Hour}
                                />
                                <span>-</span>
                                <TimePicker
                                    onChange={newTimeObj=>{
                                        setDateErrors(p=>p.filter(e=>e!=='time_range'))
                                        setEndTime(newTimeObj)
                                    }}
                                    minuteInterval={15}
                                    hour={endTime.hour}
                                    minute={endTime.min}
                                    period={endTime.p}
                                    isTime24Hour={isTime24Hour}
                                />
                            </div>
                            {dateErrors.includes('time_range')&&
                                <small className="d-block text-danger">
                                    Please enter a valid time range
                                </small>
                            }
                        </Col>
                    </Row>
                    {(editSeries || !editData) && repeatEvent()}
                    {dateError && <div className="text-danger"> enter valid date and time range</div>}

                    {isTrainerOrGym && <Form.Group className="mt-4">
                        <Form.Label> Type </Form.Label>
                        <Select
                            options={eventTypeOptions}
                            value={
                                chosenType
                            }
                            onChange={(e) => setChosenType(e)}
                        />

                    </Form.Group>}
                    {(chosenType?.value==='training'||chosenType?.value==='group_session')&&
                        <div className="mb-4">
                            <Form.Check
                                onChange={e=>{
                                    setCreateSessionWorkouts(e.target.checked)
                                }}
                                checked={createSessionWorkouts}
                                className="mb-1" 
                                id="create-workouts-check" 
                                label={`Add ${chosenType?.value==='group_session'?'class':'training session'} as a workout to ${isClient?'your calendar':'client calendars'}.`}
                            />
                            {(chosenType.value==='training'&&!isClient)&&
                                <div>
                                    <Form.Check
                                        disabled={noEndDate&&repeatType?.value!=='none'}
                                        onChange={e=>{
                                            setDeductSesions(e.target.checked)
                                        }}
                                        checked={deductSessions&&(!noEndDate||repeatType?.value==='none')}
                                        id="deduct-sessions-check"
                                        label={`Deduct session credits${noEndDate&&repeat!=='none'?' (end date required)':''}`}
                                    />
                                </div>
                            }
                            {(createSessionWorkouts&&noEndDate)&&
                                <small className="text-danger"> 
                                    <i className="fa fa-info-circle mr-1"/>
                                    If you don't specify an end date you can only sync 100 workouts at a time. You can re-sync 100 more in the future when needed.
                                </small>
                            }
                        </div>
                    }
                    {chosenType?.value==='semi_private'&&
                        <div>
                            <small>Training Session Size</small>
                            <Form.Control 
                                value={groupSessionSize}
                                onChange={e=>{
                                    setGroupSessionSize(e.target.value)
                                }}
                            />
                            <Form.Check
                                onChange={e=>{
                                    setCreateSessionWorkouts(e.target.checked)
                                }}
                                checked={createSessionWorkouts}
                                id="create-semi-private-workouts-check"
                                label="Add sessions as a workout to client calendars."
                            />
                            <small>
                                <OverlayTrigger overlay={
                                    <Tooltip>
                                        For example, setting this to 5 will prevent a client from being able to cancel or sign up 5 hours before the session
                                    </Tooltip>
                                }>
                                    <i className="fa fa-info-circle mr-1"/>
                                </OverlayTrigger>
                                Signup/Cancel Limit
                            </small>
                            <Form.Control 
                                type="number"
                                onChange={e=>{
                                    setSignupCancelBuffer(e.target.value)
                                }}
                                value={signupCancelBuffer}
                                placeholder="number of hours before"
                            />
                        </div>
                    }
                    {chosenType?.value === "group_session"&&
                        <div className="mb-3">
                            <Form.Label>Class Size</Form.Label>
                            <Form.Control 
                                onChange={e=>{
                                    setGroupSessionSize(e.target.value)
                                }}
                                value={groupSessionSize||''}
                                placeholder="size" 
                            />
                            <Form.Check
                                onChange={ e => {
                                    setConsumeCreditForGroupSession(e.target.checked)
                                }}
                                label="Deduct session credit when client registers"
                                checked={consumeCreditForGroupSession}
                                id="consume-credit-check"
                                className="mt-1"
                            />
                        </div>
                    }
                    {!["personal",'notes','meeting'].includes(chosenType?.value) && isTrainerOrGym && <Form.Group as={Row}>
                        {isClientListLoading ?
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                            :
                            <>
                                <Col>
                                    <p className='p-form-label'>Clients to schedule with</p>
                                    <MultiSelect
                                        options={clientsFormatted}
                                        labelledBy="select clients"
                                        value={selectedClients}
                                        onChange={(e) => { handleSelectClient(e) }}
                                    />
                                    {(chosenType?.value === "group_session"&&repeatType?.value!=='none')&&
                                        <small className="text-danger">
                                            These clients will be registered for all repeated classes. Pre-registering clients is optional, they can view and select classes on specific dates for themselves.
                                        </small>
                                    }
                                </Col>
                            </>
                        }
                    </Form.Group>}

                    <Form.Group>
                        <Form.Label> Reminders </Form.Label>
                        <Select
                            isSearchable={false}
                            options={reminderOptions}
                            value={chosenReminder}
                            onChange={(e) => setChosenReminder(e)}
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-around">
                        <Form.Group className="d-flex">
                            <Form.Check
                                label="Push Notifications"
                                id="pushnote-check"
                                disabled={chosenReminder?.value === "0"}
                                checked={pushNotifications}
                                onChange={(e) => { setPushNotifications(e.target.checked) }} />
                        </Form.Group>
                        <Form.Group className="d-flex">
                            <Form.Check
                                id="email-check"
                                label="Email Notifications"
                                disabled={chosenReminder?.value === "0"}
                                checked={emailNotifications}
                                onChange={(e) => { setEmailNotifications(e.target.checked) }} />
                        </Form.Group>
                    </div>


                    {(editData.status != "2") && <>
                        <div className="mt-4 mb-1"> Additional Calendars </div>
                        <OverlayTrigger overlay={
                            <Tooltip>Add to google calendar</Tooltip>
                        }>
                            <Button className="mt-2" variant={"outline-primary"} size="sm" onClick={() => {
                                let download = false;
                                handleCreateLink(download)
                            }} >
                                <i class="fab fa-google"> </i>
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                            <Tooltip>Download to apple calendar</Tooltip>
                        }>
                            <Button className="mt-2 ml-2" variant={"outline-primary"} size="sm" onClick={() => {
                                let download = true;
                                handleCreateLink(download)
                            }}
                            >
                                <i class="fab fa-apple"></i>
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                            <Tooltip>Download to outlook calendar</Tooltip>
                        }>
                            <Button className="mt-2 ml-2" variant={"outline-primary"} size="sm" onClick={() => {
                                let download = true;
                                handleCreateLink(download)

                            }}
                            >
                                <i class="fas fa-envelope"></i>
                            </Button>
                        </OverlayTrigger>
                    </>}
                </Form>
                <hr className="my-2"/>
                {isTrainerOrGym && editData.status == "0" && 
                    <div className="text-right mb-1">
                        <DeductSessionCheck
                            client_id={editData.client_ids}
                            checked={deductSession}
                            onChange={e=>{
                                setDeductSesion(e.target.checked)
                            }}
                            label="Deduct a session after accepting"
                        />
                    </div>
                }
                <div className="d-flex justify-content-between">
                    {(isTrainerOrGym && editData.status == "0") ?
                        <Button className="" variant="outline-danger" size="sm" onClick={() => {
                            let status = "2";
                            handleSaveEvent(status)
                        }}>
                            {isDeleting ? <Spinner animation="border" size="sm" /> : "Decline"}
                        </Button> :
                        editData && 
                        determineDeletePermissions(isClient, isTrainerOrGym, editData.status) && 
                        <div className="mr-auto">
                            {
                                !confirmDelete ?
                                    <Button variant="danger" size="sm" onClick={() => { handleDeleteEvent() }}>
                                        {!isDeleting ? "Delete" : <Spinner animation="border" size="sm" className="text-white" />}
                                    </Button>
                                    :
                                    <>
                                        <Button size="sm"
                                            onClick={() => { setConfirmDelete(false) }}
                                            variant="outline-dark"
                                            className="mr-1"
                                        >
                                            Cancel
                                        </Button>
                                        <Button size="sm" onClick={dispatchDelete} variant="danger">
                                            {
                                                !isDeleting ?
                                                    `Delete ${editSeries ? 'the entire series?' : "this event"}` :
                                                    <Spinner animation="border" size="sm" className="text-white" />
                                            }

                                        </Button>
                                    </>
                            }

                        </div>

                    }
                    {isTrainerOrGym && editData.status == "0" && 
                        <Button
                            onClick={()=>{
                                handleSaveEvent()
                            }}
                            size="sm" 
                        >
                            {isSaving 
                                ? <Spinner animation="border" size="sm" className="text-white" /> 
                                : "Accept"
                            }
                        </Button>
                    }

                    {((isTrainerOrGym && editData.status != "0") || !isTrainerOrGym) &&

                        <Button 
                            size="sm" 
                            onClick={()=>{
                                handleSaveEvent()
                            }}
                        >
                            {isSaving 
                                ? <Spinner animation="border" size="sm" className="text-white" /> 
                                : ( isClient ? "Save Request" : "Save" )
                            }
                        </Button>
                    }
                </div>
            </Modal.Body>
        </Modal >
    )
}

export default ScheduleModal